<template>
  <section id="section1"  >
      <v-row align="center" justify="center">
        <v-col cols="10">
          <v-row align="center" justify="center">
            <v-col cols="12" md="9" xl="9">
              <div class="text-center mt-4">
                <h1 class="section-title font-weight-light">С нами вернете больше и быстрее</h1>
              </div>
            </v-col>
            <v-col cols="12" md="9" xl="9" class="mt-6 mb-6 section1-cards" style="padding-left: 0; padding-right: 0;">
              <v-row>
                <v-col cols="12" sm="3">
                  <v-card class="card pa-4 text-center" elevation="0">
                    <div>
                      <v-img
                          :eager="true"
                          src="@/assets/image/money.png"
                          max-width="100px"
                          class="d-block ml-auto mr-auto"
                      ></v-img>
                    </div>
                    <h1 class="font-weight-regular">Оплата по факту</h1>
                    <h4 class="font-weight-regular subtitle-1">
                      Мы берем оплату только по факту готовности документов.
                    </h4>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="3">
                  <v-card class="card pa-4 text-center" elevation="0">
                    <div>
                      <v-img
                          :eager="true"
                          src="@/assets/image/error.png"
                          max-width="100px"
                          class="d-block ml-auto mr-auto"
                      ></v-img>
                    </div>
                    <h1 class="font-weight-regular">Гарантия качества</h1>
                    <h4 class="font-weight-regular subtitle-1">
                      В случае отказа Налоговой мы бесплатно скорректируем документы или вернем вам деньги
                    </h4>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="3">
                  <v-card class="card pa-4 text-center" elevation="0">
                    <div>
                      <v-img
                          :eager="true"
                          src="@/assets/image/time.png"
                          max-width="100px"
                          class="d-block ml-auto mr-auto"
                      ></v-img>
                    </div>
                    <h1 class="font-weight-regular">Экономьте свое время</h1>
                    <h4 class="font-weight-regular subtitle-1">
                      Мы сэкономим ваше время и подготовим необходимые документы.
                    </h4>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="3">
                  <v-card class="card pa-4 text-center" elevation="0">
                    <div>
                      <v-img
                          :eager="true"
                          src="@/assets/image/money.png"
                          max-width="100px"
                          class="d-block ml-auto mr-auto"
                      ></v-img>
                    </div>
                    <h1 class="font-weight-regular">Получите максимальный вычет</h1>
                    <h4 class="font-weight-regular subtitle-1">
                      Мы грамотно оптимизируем налоги с максимальной выгодой для вас.
                    </h4>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
  </section>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="scss">
#section1 .v-parallax__image-container {
  opacity: 0.5;
}

.section1-cards {
  .card {
    background: transparent !important;

    .v-icon {
      font-size: 55px !important;
      color: #005096 !important;
    }
  }

  h1 {
    font-size: 20px;
    color: #212020;
    margin-bottom: 10px;
    margin-top: 10px;
  }

  h4 {
    padding-top: 10px;
    line-height: 1.3 !important;
    color: #535050;
    font-family: "open sans", sans-serif;
    font-size: 16px;
  }

}

::v-deep .v-parallax__image {
  transform: translate(-45%, 100px) !important;
  height: 600px;
}

.svg-border-waves .v-image {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3rem;
  width: 100%;
  overflow: hidden;
}

.svg-border-waves img {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  margin-bottom: -2px;
  z-index: -1;
}

@media (max-width: 950px) {
  #section1 {
    .v-parallax {
      height: 700px !important;
    }
  }
}

@media (max-width: 630px) {
  #section1 {
    .v-parallax {
      height: 800px !important;
    }
  }
}

@media (max-width: 600px) {
  #section1 {
    .v-parallax {
      height: 1200px !important;
    }
  }
}
</style>
